import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  retakeTour: {
    id: 'header.retakeTour',
    defaultMessage: 'Guided tour',
  },
  retakeTourAriaLabel: {
    id: 'header.retakeTourAriaLabel',
    defaultMessage: 'retake guided tour',
  },
  localization: {
    id: 'header.localization',
    defaultMessage: 'Language menu',
  },
  notificationToolTip: {
    id: 'header.notificationToolTip',
    defaultMessage: 'Notifications',
  },
  localizationAriaLabel: {
    id: 'header.localizationAriaLabel',
    defaultMessage: 'change Language menu',
  },
  chatBot: {
    id: 'header.chatBot',
    defaultMessage: 'Copilot',
  },
  // Changes made by Vinay Reddy Vippala - 2026-07-14 - a11y (WCAG 1.1.1 image-alt): i18n alt text for the Coherence header logo, applied by AppHeader when the logo mounts without an accessible name.
  headerLogoAlt: {
    id: 'header.headerLogoAlt',
    defaultMessage: 'Microsoft',
  },
  financeSupportBotAriaLabel: {
    id: 'header.financeSupportBotAriaLabel',
    defaultMessage: 'Copilot',
  },
  feedback: {
    id: 'header.feedback',
    defaultMessage: 'Feedback',
  },
  profile: {
    id: 'header.profile',
    defaultMessage: 'Profile menu',
  },
  expandMenu: {
    id: 'header.expandMenu',
    defaultMessage: 'expanded',
  },
  commandBarAriaLabel: {
    id: 'header.commandBarAriaLabel',
    defaultMessage: 'Main header, please use the left and right arrow keys to navigate between items',
  },
  globalSearch: {
    id: 'header.globalSearch',
    defaultMessage: 'Global Search',
  },
  globalSearchPlaceHolderText: {
    id: 'header.globalSearchPlaceHolderText',
    defaultMessage: 'Search',
  },
  helpSettingsTitle: {
    id: 'header.helpSettingsTitle',
    defaultMessage: 'Help',
  },
  helpSettingsBackButton: {
    id: 'header.helpSettingsBackButton',
    defaultMessage: 'Help Panel Back Button',
  },
  helpSettingsBackButtonAriaLabel: {
    id: 'header.helpSettingsBackButtonAriaLabel',
    defaultMessage: 'Help Panel Back Button for multiple level content navigation',
  },
  settingsNotificationsTitle: {
    id: 'header.settingsNotificationsTitle',
    defaultMessage: 'Notifications',
  },
  settingsSettingsTitle: {
    id: 'header.settingsSettingsTitle',
    defaultMessage: 'Settings',
  },
  settingsSettingsPrimaryButton: {
    id: 'header.settingsSettingsPrimaryButton',
    defaultMessage: 'Save',
  },
  settingsSettingsPrimaryButtonAriaLabel: {
    id: 'header.settingsSettingsPrimaryButtonAriaLabel',
    defaultMessage: 'Save Settings',
  },
  insightCloseButtonAriaLabel:{
      id: 'header.insightCloseButtonAriaLabel',
      defaultMessage: 'Close Insights Panel',
  },
  settingsSettingsSecondaryButton: {
    id: 'header.settingsSettingsSecondaryButton',
    defaultMessage: 'Cancel',
  },
  settingsSettingsSecondaryButtonAriaLabel: {
    id: 'header.settingsSettingsSecondaryButtonAriaLabel',
    defaultMessage: 'Cancel current Settings',
  },
  noNewNotifications: {
    id: 'header.noNewNotifications',
    defaultMessage: 'You are all caught up! No new alerts or notifications.',
  },
    copilotName: {
      id: 'header.copilotName',
      defaultMessage: 'ECIF Agent',
    },
  copilotWelcomeMessage: {
    id: 'header.copilotWelcomeMessage',
    defaultMessage: "Hello! I'm your ECIF Agent, here to assist you with your ECIF related questions. We're also taking the first step to support workscope data related queries and are excited to bring you advanced features like ECIF Case tracking in the near future.<br><br>At any stage if you want to open a ticket, please click on Create a Support ticket button.<br><br>To get you started, here are some top questions you might find helpful."
  },
  copilotWelcomeSuggestion: {
    id: 'header.copilotWelcomeSuggestion',
    defaultMessage: '["Explain pre-sales ECIF and how is it different from post-sales ECIF? ", "What do the different ECIF supplier status mean? Compare based on common attributes.","I don’t see the supplier I am looking for in the search view, what should I do?","Give a break-up by Request Type of all the Workscopes created, show count and total value, limit only to Completed.","Provide details about the Case with id [Case number]","Provide the most frequently used supplier for workscopes in [Service Location Name]."]'
  },
  copilotPromptsSuggestions: {
    id: 'header.copilotPromptsSuggestions',
    defaultMessage: '["ECIF case associated to Opportunity [opportunity ID]","Contract details for case [Case number]","PO number & status created for case [Case number]","Provide details about the Case with id [Case number]","Provide the most frequently used supplier for workscopes in [Service Location Name]."]'
  },
  copilotPromptsSuggestionsTitle: {
    id: 'header.copilotPromptsSuggestionsTitle',
    defaultMessage: 'ECIF Central Agent Prompt Gallery'
  },
  copilotCustomerYield: {
    id: 'header.copilotCustomerYield',
    defaultMessage: 'Customer ECIF Yield [TPID]'
  },
  support: {
    id: 'header.support',
    defaultMessage: 'Raise a Support Ticket',
  },
  helpVideos: {
    id: 'header.helpVideos',
    defaultMessage: 'Help Videos',
  },
  FAQ: {
    id: 'header.FAQ',
    defaultMessage: 'FAQs',
  },
  requestTechnicalSupport: {
    id: 'header.Request Technical Support',
    defaultMessage: 'Raise a support ticket',
  },
  raiseBusinessSupport: {
    id: 'header.Request ECIF Business Support',
    defaultMessage: 'Request ECIF Business Support',
  },
  guidedTour: {
    id: 'header.guidedTour',
    defaultMessage: 'Guided Tour',
  },
  whatsNew: {
    id: 'header.whatsNew',
    defaultMessage: "What's New",
  },
  competitiveBid: {
    id: 'header.competitiveBid',
    defaultMessage: 'Competitive Bid',
  },
  competitiveBidProperty: {
    id: 'header.competitiveBidProperty',
    defaultMessage: 'competitiveBid'
  },
  ECIFProjectIsNotCompetitiveBid: {
    id: 'header.ECIFProjectIsNotCompetitiveBid',
    defaultMessage: 'No'
  },
  userVoice: {
    id: 'header.userVoice',
    defaultMessage: 'User Voice',
  },
  mcapshelp: {
    id: 'header.mcapshelp',
    defaultMessage: 'MCAPSHelp',
  },
  roadmap: {
    id: 'header.roadmap',
    defaultMessage: 'Roadmap',
  },
  privacyNotice: {
    id: 'header.privacyNotice',
    defaultMessage: 'Privacy Notice',
  },
  walkingDeck: {
    id: 'header.walkingDeck',
    defaultMessage: 'Walking Deck',
  },
  customHelp: {
    id: 'header.customHelp',
    defaultMessage: 'Help',
  },
  customPanelHeaderText: {
    id: 'header.customPanelHeaderText',
    defaultMessage: 'Help Videos',
  },
  insights: {
    id: 'header.insights',
    defaultMessage: 'Insights',
  },
  aboutPageTile: {
    id: 'about.Title',
    defaultMessage: 'About ECIF Workscope'
  },
  raiseSupportTicket: {
    id: 'header.raiseSupportTicket',
    defaultMessage: 'Raise a Support Ticket',
  },
  whatsNewPageTile: {
    id: 'whatsNew.Title',
    defaultMessage: "What's New"
  },
  privacyNoticePageTile: {
    id: 'privacyNotice.Title',
    defaultMessage: 'Privacy Notice'
  },
  breadcrumbButton: {
    id: 'header.breadcrumbButton',
    defaultMessage: 'breadcrumbButton-Home-0'
  },
  back_to_dashboard_button_id: {
    id: 'workscopeName.backToDashboardButton',
    defaultMessage: 'back-to-dashboard-button-id'
  },
  alertActions: {
    id: "dashboard.alertActions",
    defaultMessage: "Action"
  },
  dropdownfilter:{
    id: 'dashboard.dropdownfilter',
    defaultMessage: 'dropdownfilter',
  },
  viewFilterElement:{
    id: 'header.viewFilterElement',
    defaultMessage: 'workscope-filter-dropdown-container'
  },
  templateVersionFailedMessage:{
    id:'header.templateVersionFailedMessage',
    defaultMessage:'Something went wrong'
  },
  messageDeliveryAgent: {
    id: 'header.messageDeliveryAgent',
    defaultMessage: 'Ask a question or request',
  },
  usedByDisclaimer: {
    id: 'header.usedByDisclaimer',
    defaultMessage: 'Microsoft Internal Only',
  }
});

// Generated by GitHub Copilot | author: Vinay Reddy Vippala | Updated on: 2026-07-14 | ~4 lines modified | a11y: added headerLogoAlt i18n message for the Coherence header logo image-alt fix (WCAG 1.1.1).
